<template>
  <div class="right-stack">
    <section class="center-card judgement-card">
      <div class="card-title">生长状态研判</div>
      <div ref="judgeChartRef" class="judge-chart"></div>
    </section>
    <section class="center-card strategy-card">
      <div class="card-title">精准管理策略</div>
      <div class="strategy-flow">
        <span v-for="(item, index) in strategy" :key="index">
          {{ item }}
        </span>
      </div>
    </section>
  </div>
</template>

<script setup>
import * as echarts from "echarts";
import { onBeforeUnmount, onMounted, ref } from "vue";

const strategy = ["灌溉指导", "追肥指导", "通风指导", "植保预警"];

const judgeChartRef = ref(null);
let judgeChart = null;

const stateData = [
  { name: "适宜生长", value: 62, itemStyle: { color: "#54fff0" } },
  { name: "轻微水分胁迫", value: 23, itemStyle: { color: "#b8ff9c" } },
  { name: "养分偏低", value: 9, itemStyle: { color: "#ffe26d" } },
  { name: "病虫害风险", value: 6, itemStyle: { color: "#51dfff" } },
];

const judgeOption = {
  legend: {
    bottom: 0,
    left: "center",
    itemWidth: 12,
    itemHeight: 12,
    itemGap: 30,
    icon: "circle",
    textStyle: {
      color: "#ffffff",
      fontSize: 26,
      // fontWeight: "bold",
    },
    data: stateData.map((item) => item.name),
  },
  tooltip: {
    trigger: "item",
    backgroundColor: "rgba(6, 42, 44, 0.92)",
    borderColor: "rgba(95, 255, 240, 0.5)",
    textStyle: { color: "#fff", fontSize: 22 },
    formatter: ({ marker, name, value }) => `${marker}${name}：${value}%`,
  },
  graphic: [
    {
      type: "text",
      left: "40%",
      top: "42%",
      style: {
        text: "78",
        fill: "#ffffff",
        fontSize: 38,
        fontWeight: 900,
        textAlign: "center",
        textShadowColor: "rgba(255,255,255,.38)",
        textShadowBlur: 10,
      },
    },
    {
      type: "text",
      left: "44%",
      top: "50%",
      style: {
        text: "长势指数",
        fill: "#ffffff",
        fontSize: 22,
        fontWeight: 900,
        textAlign: "center",
      },
    },
  ],
  series: [
    {
      type: "pie",
      silent: true,
      center: ["50%", "47%"],
      radius: ["40%", "55%"],
      startAngle: 218,
      clockwise: true,
      hoverAnimation: false,
      label: { show: false },
      labelLine: { show: false },
      itemStyle: {
        borderColor: "rgba(3, 32, 35, 0.9)",
        borderWidth: 8,
        shadowBlur: 12,
        shadowColor: "rgba(84, 255, 240, 0.35)",
      },
      data: stateData,
    },
    {
      type: "pie",
      silent: true,
      center: ["50%", "47%"],
      radius: ["28%", "31%"],
      startAngle: 90,
      hoverAnimation: false,
      label: { show: false },
      labelLine: { show: false },
      itemStyle: {
        color: "rgba(112, 255, 245, 0.13)",
        borderColor: "rgba(112, 255, 245, 0.28)",
        borderWidth: 1,
      },
      data: Array.from({ length: 48 }, () => ({ value: 1 })),
    },
    {
      type: "pie",
      center: ["50%", "47%"],
      radius: ["60%", "61%"],
      startAngle: 92,
      hoverAnimation: false,
      minShowLabelAngle: 0,
      label: {
        show: true,
        position: "outside",
        alignTo: "edge",
        edgeDistance: 10,
        bleedMargin: 0,
        formatter: ({ name, value, dataIndex }) => {
          // if (dataIndex === 0) return `{name|${name}}`;
          return `{value|${value}%}`;
        },
        rich: {
          value: {
            color: "#6ffff2",
            fontSize: 24,
            fontWeight: 900,
          },
          name: {
            color: "#ffffff",
            fontSize: 24,
            fontWeight: 900,
          },
        },
      },
      labelLine: {
        show: true,
        length: 10,
        length2: 5,
        lineStyle: {
          color: "rgba(116, 255, 246, 0.55)",
          width: 1,
        },
      },
      itemStyle: { color: "transparent" },
      data: stateData,
    },
  ],
};

function resizeJudgeChart() {
  judgeChart && judgeChart.resize();
}

onMounted(() => {
  judgeChart = echarts.init(judgeChartRef.value);
  judgeChart.setOption(judgeOption);
  window.addEventListener("resize", resizeJudgeChart);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeJudgeChart);
  judgeChart && judgeChart.dispose();
});
</script>

<style lang="less" scoped>
@import "./centerPanelShared.less";

.right-stack {
  min-height: 0;
  display: grid;
  grid-template-rows: minmax(0, 1fr) 268px;
  gap: 34px;
}

.judge-chart {
  width: 100%;
  height: calc(100% - 8px);
  min-height: 0;
}

.strategy-card {
  padding-bottom: 24px;
}

.strategy-flow {
  margin-top: 40px;
  // height: calc(100% - 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px 0;
  padding: 20px 18px;
  box-sizing: border-box;
  border: 1px solid rgba(76, 255, 239, 0.8);
  border-radius: 10px;
  background: linear-gradient(90deg, rgba(11, 117, 108, 0.5), rgba(20, 153, 139, 0.2));
}

.strategy-flow span {
  position: relative;
  width: 40%;
  color: #ffffff;
  font-size: 26px;
  font-weight: bold;
  line-height: 28px;
  text-align: center;
}
.strategy-flow span::after{
  content: "";
  position: absolute;
  width: 2px;
  height: 100%;
  background: rgba(255, 255, 255, 0.78);
  top: 50%;
  transform: translateY(-50%);
  right: 0;

}
.strategy-flow  span:nth-child(2n)::after {
  display: none;
}
</style>
